var $ = require('jquery');

function unobfuscateEmail(email){
  return email.split("").reverse().join("").replace(' ### ', '@');
}

function makeEmailLinks(){
  $.each($('span.js-obfuscated-email:not(.link-ready)'), function(){
    $(this).addClass('link-ready');

    var email = unobfuscateEmail($(this).data('href'));
    var text = unobfuscateEmail($(this).data('text'));

    if(email && email !== ''){
      var linkText = text && text !== '' ? text : email;
      var emailLink = '<a href="mailto:'+email+'">'+linkText+'</a>';
      $(this).html(emailLink);
    }
  });
}


function init() {
  makeEmailLinks();
}

module.exports = {
  init,
  unobfuscate: unobfuscateEmail,
  makeLinks: makeEmailLinks
};
